import{switchMap as t}from"./switchMap.js";import{identity as i}from"../util/identity.js";function r(){return t(i)}export{r as switchAll};
